import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  container: {
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  titleItem: { minWidth: 0 },
  title: { color: theme.palette.text.primary, overflowWrap: 'anywhere' },
  createButton: {
    textTransform: 'capitalize',
    color: theme.palette.primary.main,
    '&:hover': { backgroundColor: theme.palette.button.hover },
    [theme.breakpoints.down('sm')]: { width: '100%' },
    // DESIGN.md §9: touch devices get ~44px targets; mouse density unchanged.
    '@media (hover: none) and (pointer: coarse)': { minHeight: 44 },
  },
  buttonItem: {
    [theme.breakpoints.down('sm')]: { width: '100%' },
  },
  createButtonText: { fontWeight: 500 },
  createIcon: { marginLeft: theme.spacing(1) },
  tooltipButton: {
    width: theme.spacing(3.7),
    height: theme.spacing(3.7),
    color: theme.palette.grey[700],
  },
}));

type Props = {
  handleModalOpen: (state: boolean) => void;
};

export const Header: FC<Props> = ({
  handleModalOpen,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="space-between" alignItems="center" className={classes.container}>
      <Grid item className={classes.titleItem}>
        <Typography variant="h4" className={classes.title}>
          {t('charges:chargeSettings')}
        </Typography>
      </Grid>

      <Grid item className={classes.buttonItem}>
        <Button
          disableElevation
          variant="contained"
          color="secondary"
          className={classes.createButton}
          onClick={() => handleModalOpen(true)}
        >
          <Typography variant="body2" className={classes.createButtonText}>
            {t('charges:addNew')}
          </Typography>

          <FontAwesomeIcon
            icon="plus"
            size="sm"
            className={classes.createIcon}
          />
        </Button>
      </Grid>
    </Grid>
  );
};
